import { useGenericQuery } from '../../../core/api/reactQuery';
import { loadCourse } from '../../../core/queries/course';
import { useCoursesStore } from '../stores/courseStore';

function useLoadCourse(slug: string) {
  const { setLoadedCourse } = useCoursesStore();
  const { data, isError, error, isSuccess, isLoading } = useGenericQuery(
    ['load-course', slug],
    () => loadCourse(slug),
    setLoadedCourse
  );

  return {
    data,
    isError,
    isLoading,
    error,
    isSuccess,
  };
}

export { useLoadCourse };
